import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ReplaceCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M4 5h6v6H4zM14 14h6v6h-6z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M13 5.854h4a2 2 0 0 1 2 2V10m-3.937-2L13 5.854 15.063 4M10 19H6a2 2 0 0 1-2-2v-2m4 6 2-2-2-2" })));
}
const ReplaceCustom = forwardRef(_ReplaceCustom);
export { ReplaceCustom };
